module.exports = __webpack_public_path__ + "img/073683.f6f160de.png";